import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import stationsServices from './satationGroupService';
import type {
  STATION_GROUP,
  ADD_STATION_GROUP,
  STATION_GROUP_STATIONS,
  UPDATE_STATION_GROUP,
} from './stationGroups.type';
import type FILTERS from '../../../../common/filters.type';

const initialState = {
  isLoading: false,
  stationGroups: [] as STATION_GROUP[],
  stationGroupStations: {
    totalDataCount: 0,
    page_size: 10,
    page_number: 1,
    sort_by: 'name',
    ascending: true,
    search: '',
    pageData: [] as STATION_GROUP_STATIONS[],
  },
};

export const groupList = createAsyncThunk('groupList', async (payload, thunkAPI) => {
  try {
    const data: AxiosResponse = await stationsServices.groupList();

    return data;
  } catch (error) {
    const result = error as AxiosError;

    return thunkAPI.rejectWithValue(result.message);
  }
});
export const stationGroupStations = createAsyncThunk(
  'stationGroupStations',
  async (payload: {groupId: number; filters: FILTERS}, thunkAPI) => {
    try {
      const data: AxiosResponse = await stationsServices.stationGroupStations(payload);

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const addGroup = createAsyncThunk(
  'addGroup',
  async (payload: ADD_STATION_GROUP, thunkAPI) => {
    try {
      const data: AxiosResponse = await stationsServices.addGroup(payload);

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const updateStationGroup = createAsyncThunk(
  'updateStationGroup',
  async (values: {groupId: number; payload: UPDATE_STATION_GROUP}, thunkAPI) => {
    try {
      const data: AxiosResponse = await stationsServices.updateGroup(values);

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const stationGroupsSlice = createSlice({
  name: 'stationGroupsSlice',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    pageNumberChange(state, action: PayloadAction<number>) {
      state.stationGroupStations.page_number = action.payload;
    },
    pageSizeChange(state, action: PayloadAction<number>) {
      state.stationGroupStations.page_number = 1;
      state.stationGroupStations.page_size = action.payload;
    },
    searchBy(state, action: PayloadAction<string>) {
      state.stationGroupStations.page_number = 1;
      state.stationGroupStations.search = action.payload;
    },
    sortBy(state, action: PayloadAction<{ascending: boolean; sortBy: string}>) {
      state.stationGroupStations.ascending = action.payload.ascending;
      state.stationGroupStations.sort_by = action.payload.sortBy;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(groupList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(groupList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.stationGroups = action.payload.data;
    });
    builder.addCase(groupList.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(addGroup.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addGroup.fulfilled, (state) => {
      state.isLoading = false;
      message.success(`Group added Successfully`);
    });
    builder.addCase(addGroup.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(updateStationGroup.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateStationGroup.fulfilled, (state) => {
      state.isLoading = false;
      message.success(`Station Group updated Successfully`);
    });
    builder.addCase(updateStationGroup.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(stationGroupStations.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(stationGroupStations.fulfilled, (state, action) => {
      state.isLoading = false;
      state.stationGroupStations = action.payload.data;
    });
    builder.addCase(stationGroupStations.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });
  },
});
export const {pageNumberChange, pageSizeChange, searchBy, sortBy} = stationGroupsSlice.actions;

export default stationGroupsSlice.reducer;
